import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "../../../../shared/components/form/Form";
import { Input } from "../../../../shared/components/input/Input";
import { Button } from "../../../../shared/components/button/Button";
import { SymbolIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import useToastWrapper from "../../../../hooks/useToastWrapper";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const RestorePasswordForm = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToastWrapper();

  const validationSchema = yup.object().shape({
    password: yup
      .string()
      .required("La contraseña es obligatoria")
      .matches(
        "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).{8,16}$",
        "La contraseña debe tener entre 8 y 16 caracteres, una letra mayúscula, una minúscula y un número",
      ),
    passwordAgain: yup
      .string()
      .oneOf([yup.ref("password"), null], "La contraseña no coincide")
      .required("La contraseña es obligatoria")
      .matches(
        "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).{8,16}$",
        "La contraseña debe tener entre 8 y 16 caracteres, una letra mayúscula, una minúscula y un número",
      ),
  });

  const form = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { password: "", passwordAgain: "" },
  });

  const onSubmitHandler = async (values) => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/passwords/restore`, {
      method: "POST",
      body: JSON.stringify({
        token: token,
        password: {
          newPassword: values.password,
          newPasswordAgain: values.passwordAgain,
        },
      }),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            toast.success(data.message);
          } else {
            toast.error(data.message);
          }
        } else {
          const jsonResponse = await response.json();
          const message = jsonResponse.message;
          throw new Error(message);
        }
      })
      .catch((e) => {
        toast.error(`Error cambiando de contraseña: ${e}`);
        console.log(`Error fetched: ${e}`);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmitHandler)}
        className="w-full px-5"
      >
        <div className="flex flex-col justify-center gap-y-2">
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input placeholder="Nueva contraseña" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="passwordAgain"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input placeholder="Repita nueva contraseña" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex flex-row mt-4 justify-center">
          <Button className="w-full" type="submit" disabled={isLoading}>
            {isLoading && <SymbolIcon className="mr-2 h-4 w-4 animate-spin" />}
            Cambiar nueva contraseña
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default RestorePasswordForm;
